import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { finopsApiRef, FinOpsClient } from './api';

export const finopsPlugin = createPlugin({
  id: 'finops',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: finopsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new FinOpsClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const FinOpsPage = finopsPlugin.provide(
  createRoutableExtension({
    name: 'FinOpsPage',
    component: () =>
      import('./components/FinOpsRouter').then(m => m.FinOpsRouter),
    mountPoint: rootRouteRef,
  }),
);
